import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  FDBox, FDStack,
} from '@facet-wealth/design';
import AccordionSummaryCardWithNestedItems
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker/AccordionSummaryCard/Content/AccordionSummaryCardWithNestedItems';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {},
  actionIndexCircle: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    width: '24px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  cardContainer: {
    width: '100%',
    display: 'flex',
  },
});

const Action = ({ classes, index }) => {
  return (
    <FDBox width="100%">
      <FDStack alignItems="center" spacing={2} justifyContent="flex-start">
        <div className={classes.actionIndexCircle}>
          <Typography variant="h6" weight="bold" color="white">
            {String(index + 1)}
          </Typography>
        </div>
        <FDBox width="100%">
          <AccordionSummaryCardWithNestedItems />
        </FDBox>
      </FDStack>
    </FDBox>
  );
};

Action.defaultProps = {};

Action.propTypes = {
  classes: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default withStyles(styles)(Action);
